import React from "react";
import { SCButtonMB } from "./styles";

const ButtonMB = (params) => (
  <SCButtonMB
    onClick={params.clickAction || params.onClick}
    className={params.className ? params.className : "button-mb"}
    disabled={params.disabled}
  >
    {params.icon ? params.icon : ""}
    {params.icon ? " " : ""}
    {!params.capitalize ? params.title : params.title}
    {params.rightIcon ? " " : ""}
    {params.rightIcon ? params.rightIcon : ""}
  </SCButtonMB>
);

export default ButtonMB;
